import { Validators } from '@angular/forms';

export class Validation {
  public rules = (): object => {
    return {
      selecaoEmpresa: [''],
      numeroTerminal: ['', [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      sim: ['', [Validators.required, Validators.maxLength(30)]],
      imei: ['', [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      senha: ['123456', [Validators.required, Validators.maxLength(30)]],
      placa: ['', [Validators.required, Validators.maxLength(8)]],
      idVeiculo: ['', [Validators.required]],
      capacidadeanque: ['', [Validators.required]],
      coeficienteConsumo: ['', [Validators.required]],
      odometro: ['', [Validators.required]],
      odometroParcial: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      nomeProprietario: ['', [Validators.required, Validators.maxLength(100)]],
      telefoneProprietario: ['', [Validators.required, Validators.maxLength(20)]],
      telefoneCentral: ['', [Validators.required, Validators.maxLength(20)]],
      voltagem: ['', [Validators.required]],
      idTerminalProtocolo: ['', [Validators.required]],
      idTerminalIcone: ['1', [Validators.required]],
      rfidEventType: ['PASSENGER'],
      fusoHorarioEnum: ['0', [Validators.required]],
      fusoHorario: ['GMT-03:00', [Validators.required]],
      fusoHorarioExibicao: ['GMT-03:00', [Validators.required]],
      observacao: ['', Validators.required],
      conectado: ['', Validators.required],
      instalado: ['', Validators.required],
      idEmpresa: [''],
      empresaEdit: [''],
      nomeOut1: [''],
      nomeOut2: [''],
      nomeOut3: [''],
      nomeOut4: [''],
      nomeOut5: [''],
      nomeOut6: [''],
      nomeIn1: [''],
      nomeIn2: [''],
      nomeIn3: [''],
      nomeIn4: [''],
      nomeIn5: [''],
      nomeIn6: [''],
      nomeIn7: [''],
      nomeIn8: [''],
      nomeIn9: [''],
      nomeIn10: [''],
      minutoAlarmeParada: [''],
      minutoAlarmeExcessoDirecao: ['100'],
      minutoAlarmePontoMorto: [''],
      enumTipoVelocidade: ['', Validators.required],
      limiteExcessoVeloc: ['', Validators.required],
      limiteExcessoVelocChuva: ['', Validators.required],
      limiteExcessoRpm: ['', Validators.required],
      possuiTeclado: [false],
      possuiTpms: [false],
      possuiSensorFadiga: [false],
      calcularHorimetroParado: [false],
      atualizarEmpresa: [false],
      fatorConversaoVelocidadeCan: [''],
    };
  }
}
